import { storageFactory } from 'storage-factory';

export const local = storageFactory(() => localStorage);
// unused for now, but might be useful later
// export const session = storageFactory(() => sessionStorage);
